// Import angular core
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// Import base component
import { AppComponent } from './app.component';

// Material design modules
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';


// Custom modules
import { NavbarComponent } from './fragments/navbar/navbar.component';

// Define the routes
import { AppRoutingModule } from './app-routing.module';

// Import the pages to be used in the routes
import { NotFoundComponent } from './pages/not-found/not-found.component';

// Import the interceptors
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ApiModule, Configuration } from '@solverml/api';
import { ApiModule as SSOApiModule, Configuration as SSOConfiguration } from '@rfebm/sso-api';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import environment from '@environment';
import { WiseIdAuthInterceptor } from './features/sso-wise-id/controller/wise-id-auth.interceptor';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    NotFoundComponent,
  ],
  imports: [
    ApiModule.forRoot(
      // API Configuration
      () => new Configuration({
        // Set the base path to the API
        basePath: window.location.protocol + '//' + "backend." + window.location.hostname,
        // Set mock credentials for the API
        credentials: {
          acessToken: 'lol',
          refreshToken: 'lol',
        },
      })),
    SSOApiModule.forRoot(
      // SSO API Configuration
      () => new SSOConfiguration({
        // Set the base path to the SSO API
        basePath: environment.SSO_BASE_URL,
        // Set mock credentials for the SSO API
        credentials: {
          acessToken: 'lol',
          refreshToken: 'lol',
        },
      })),
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    DragDropModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatDatepickerModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    // Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WiseIdAuthInterceptor,
      multi: true
    },
    // Form field options dynamic subscript sizing
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic'
      }
    },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode',
        }
      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
